<template>
<div class="container">
<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Another Exam</div>
<div class="panal-body">


<div class="form-group">
    <label>Exam Names</label>
   <select class="form-control" v-model="selected">
  <option>Default select</option>
    <option v-for="exam in ExamNamesList" :value="exam.RequiredExamID" v-bind:key="exam.RequiredExamID"> {{exam.ExamNameEN}}</option>
</select>
    <small id="ExamHelp" class="form-text text-muted">We'll never share your Exam with anyone else.</small>
  </div>

<div class="text-right">
    <button type="button" class="btn btn-primary mr-1" @click="bookAnotherTry">Submit</button>
    <button type="reset" class="btn btn-success" @click="Cancel()">Cancel</button>

</div>









</div>

</div>
</div>
</div>
</div>



</template>

<script>
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
export default{

    data(){
        return{
                ExamNamesList : [],
                selected:0,
        }
    },
    methods:{
            bookAnotherTry(){
                ApplicantDataServices.BookExamAnotherTry(this.currentUser.UserIDSerial,this.selected).then(Response =>{
          
            this.message  = Response.data
            this.Cancel();
           
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
            }, Cancel() {
          
      this.$emit('clicked', this.selected = 0 )
    }
    },
    mounted(){
     
        ApplicantDataServices.GetExamNames(this.currentUser.UserIDSerial,this.currentUser.SEMESTERID).then(Response =>{
          this.ExamNamesList=Response.data
           
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
    },
    computed:{
        currentUser(){
            return this.$store.state.auth.user
        }
    }
}
</script>
 
<style scoped>
 
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
}

</style>